import { createContext, useContext } from "react";
import { BulkUpdateParams } from "../../transactions/TransactionsBulkActions/lib";

type NewValueType = BulkUpdateParams["value"];

interface SimilarTransactionsNewValueContextType {
    newValuesMap: Record<number, NewValueType>;
    newValueLabelsMap: Record<number, string>;
    setNewValue: (
        transactionId: number,
        value: NewValueType,
        label?: string,
    ) => void;
    setNewValues: (
        updates: Array<{
            transactionId: number;
            value: NewValueType;
            label?: string;
        }>,
    ) => void;
    setBaseValue: (value: NewValueType, label?: string) => void;
    valueToAssign: BulkUpdateParams;
    displayedChangedEntityName?: string;
}

export const SimilarTransactionsNewValueContext =
    createContext<SimilarTransactionsNewValueContextType | null>(null);

export function useSimilarTransactionsNewValue() {
    const context = useContext(SimilarTransactionsNewValueContext);
    if (!context) {
        throw new Error(
            "useSimilarTransactionsNewValue must be used within SimilarTransactionsNewValueContext.Provider",
        );
    }
    return context;
}
